import i18n from "i18n";

const headers = [
  {
    id: "date",
    label: i18n.t("date").toUpperCase(),
    active: true,
    numeric: false,
    disablePadding: true,
    type: "Tooltip",
    style: {
      color: "#676f8f"
    }
  },
  {
    id: "type",
    label: i18n.t("order.type").toUpperCase(),
    active: true,
    numeric: false,
    disablePadding: true,
    type: "Tooltip",
    style: {
      color: "#494f66",
      fontSize: "19px",
      fontFamily: "Ubuntu-Medium"
    }
  },
  {
    id: "order",
    label: i18n.t("order").toUpperCase(),
    active: true,
    numeric: false,
    disablePadding: true,
    type: "Tooltip",
    style: {
      color: "#676f8f"
    }
  },
  {
    id: "reason",
    label: i18n.t("reason").toUpperCase(),
    active: true,
    numeric: false,
    disablePadding: true,
    type: "Tooltip",
    style: {
      color: "#676f8f"
    }
  },
  {
    id: "in",
    label: i18n.t("entry.orders").toUpperCase(),
    active: true,
    numeric: false,
    disablePadding: true,
    style: {
      color: "green"
    }
  },
  {
    id: "out",
    label: i18n.t("departure.orders").toUpperCase(),
    numeric: false,
    disablePadding: true,
    style: {
      color: "red"
    }
  },
  {
    id: "total",
    label: i18n.t("balance").toUpperCase(),
    active: false,
    numeric: false,
    disablePadding: true,
    style: {
      color: "#494f66",
      fontSize: "19px",
      fontFamily: "Ubuntu-Medium"
    }
  }
];

export default headers;
